import { InMemoryCache, NormalizedCacheObject } from '@apollo/client'

import { globalWindow } from '@emico/ssr-utils'

export const rehydratableCaches: Array<[InMemoryCache, string]> = []

export const getGlobalId = (storeView: string) => `__APOLLO_STATE__${storeView}`
export const getStoredState = (
  storeView: string,
): NormalizedCacheObject | undefined =>
  ((globalWindow as unknown) as { [key: string]: NormalizedCacheObject })?.[
    getGlobalId(storeView)
  ]
export const resetStoredState = (storeView: string) => {
  delete ((globalWindow as unknown) as {
    [key: string]: NormalizedCacheObject
  })?.[getGlobalId(storeView)]
}

export function rehydrateCache(cache: InMemoryCache, storeView: string) {
  const initialState = getStoredState(storeView)
  if (initialState) {
    cache.restore(initialState)
    resetStoredState(storeView)
  }
}
export function registerCacheForHydration(
  cache: InMemoryCache,
  storeView: string,
) {
  rehydratableCaches.push([cache, storeView])
}
